<template lang="pug">
tl-grid(
    class="tl-input-switch-text"
    :class="{ external: external || disabled }"
    :cols="large ? [['54px', 1]] : small ? [['34px', 1]] : [['40px', 1]]"
    :gap="small ? 10 : 20"
    @click="click()"
)
    tl-position(
        y="center"
    )
        tl-input-switch(
            v-model="modelState"
            :color="color"
            :disabled="disabled"
            :error="error"
            :large="large"
            :rules="rules"
            :small="small"
            style="pointer-events: none"
            @validated="(val) => (isError = val !== true)"
            @reset-error="isError = false"
        )

    tl-position(
        :class="{ 'text-color-error': isError, 'text-opaq': external || disabled, 'text-3': large, 'text-5': !large && !small, 'text-6': small }"
        class="text-value text-dense"
        y="center"
    )
        slot
</template>

<script setup>
import { computed, ref, watch, inject } from 'vue'
import { getInjects } from '@/components/$tl/utils/injects'

const props = defineProps({
    color: String,
    modelValue: Boolean,
    error: Boolean,
    external: Boolean,
    small: Boolean,
    large: Boolean,
    disabled: Boolean,
    rules: Array,
})

const emit = defineEmits(['update:modelValue'])
const injects = getInjects(props, inject)

const modelState = ref(null)

const color = computed(() => props.color ?? injects.color?.value ?? 'tl-blue')
const modelValue = computed(() => props.modelValue ?? injects.modelValue?.value)
const error = computed(() => props.error ?? injects.error?.value)
const external = computed(() => props.external ?? injects.external?.value)
const small = computed(() => props.small ?? injects.small?.value)
const large = computed(() => props.large ?? injects.large?.value)
const disabled = computed(() => props.disabled ?? injects.disabled?.value)
const rules = computed(() => props.rules ?? injects.rules?.value)

const isError = ref(props.error)
watch(error, (val) => {
    isError.value = val
})

modelState.value = modelValue.value

const click = () => {
    if (!external.value && !disabled.value) modelState.value = !modelState.value
}

watch(modelValue, (val) => {
    if (val !== modelState.value) modelState.value = val
})
watch(modelState, (val) => emit('update:modelValue', val), { immediate: true })
</script>

<style lang="sass" scoped>
.tl-input-switch-text
    cursor: pointer
    .text-value
        transition: var(--transition-default)
    &.external
        cursor: default !important
</style>
